import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    const sessionId = match ? match[1] : null;

    const run = async () => {
      if (!sessionId) { navigate("/login"); return; }
      try {
        const res = await api.post("/auth/session", { session_id: sessionId }, { headers: { "X-Session-ID": sessionId } });
        setUser(res.data);
        window.history.replaceState({}, document.title, "/admin");
        navigate(res.data.is_admin ? "/admin" : "/login", { state: { user: res.data } });
      } catch {
        navigate("/login");
      }
    };
    run();
  }, [navigate, setUser]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-cream" data-testid="auth-callback">
      <div className="text-center">
        <div className="w-12 h-12 border-4 border-hotpink border-t-transparent rounded-full animate-spin mx-auto mb-4" />
        <p className="font-heading text-xl">Signing you in…</p>
      </div>
    </div>
  );
}
